import { isMobile } from '@polyv/utils/src/browser';
import basicMixin from '../../../../assets/mixins/basic';

export default {
  props: {
    productSdk: Object,
    value: [String, Number],
  },

  mixins: [basicMixin],

  data() {
    return {
      labelList: [],
      pageNumber: 1,
      pageSize: 24,
      totalPages: 1,
      totalItems: 0,
      isLoading: false,

      leftArrowVisible: false,
      rightArrowVisible: false,

      popperVisible: false,
    };
  },

  watch: {
    value() {
      this.$nextTick(() => {
        const activeElem = document.querySelector('.plv-iar-product-label-list__item--active');
        if (activeElem && isMobile()) {
          activeElem.scrollIntoView({
            inline: 'center',
          });
          setTimeout(() => {
            this.computedArrowVisible();
          }, 10);
        }
      });
    }
  },

  computed: {
    defaultLabelItem() {
      return {
        id: '',
        name: this.iarTrans('product.all'),
      };
    }
  },

  mounted() {
    this.getLabelList(true);
  },

  methods: {
    async getLabelList(isFirst = false) {
      if (this.isLoading || this.pageNumber > this.totalPages) {
        return;
      }

      this.isLoading = true;
      try {
        const pageSize = isFirst ? this.pageSize - 1 : this.pageSize;
        const data = await this.productSdk.getProductLabelList({
          pageNumber: this.pageNumber,
          pageSize,
        });
        if (isFirst) {
          this.labelList = [this.defaultLabelItem, ...data.contents];
        } else {
          this.labelList = [...this.labelList, ...data.contents];
        }
        this.totalItems = data.totalItems;
        this.totalPages = data.totalPages;
      } catch (e) {}

      this.isLoading = false;
      this.$nextTick(() => {
        this.computedArrowVisible();
      });
    },

    closePopper() {
      this.popperVisible = false;
    },

    /** 计算箭头阴影是否显示 */
    computedArrowVisible() {
      const scrollElem = this.$refs.scrollElem;

      if (!scrollElem) return;

      const scrollLeft = Math.ceil(scrollElem.scrollLeft);
      if (scrollLeft > 0) {
        this.leftArrowVisible = true;
      } else {
        this.leftArrowVisible = false;
      }

      if (scrollLeft < Math.floor(scrollElem.scrollWidth - scrollElem.clientWidth)) {
        this.rightArrowVisible = true;
      } else {
        this.rightArrowVisible = false;
      }
    },

    onClickItem(item) {
      this.$emit('input', item.id);
      this.closePopper();
    },

    onScrollTopice(event) {
      this.onScroll(event, 'horizontal');
      this.computedArrowVisible();
    },

    onScroll(event, type) {
      if (this.pageNumber > this.totalPages) {
        return;
      }

      if (type === 'horizontal') {
        const { scrollWidth, clientWidth, scrollLeft } = event.target;

        if (clientWidth + scrollLeft > scrollWidth - clientWidth * 0.3) {
          this.pageNumber += 1;
          this.getLabelList();
        }
      }

      if (type === 'vertical') {
        const { scrollHeight, clientHeight, scrollTop } = event.target;

        if (clientHeight + scrollTop > scrollHeight - clientHeight * 0.3) {
          this.pageNumber += 1;
          this.getLabelList();
        }
      }
    },
  },
};
